import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',

    title: getDefaultValue(searchParams.get('title'), 'Присылай фото'),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    startFrom: searchParams.get('startFrom')
      ? parseInt(searchParams.get('startFrom') || '')
      : 2,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 5500,
    carousel: searchParams.get('carousel') || '1',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    titleFontSize: searchParams.get('titleFontSize') || '9.375',
    sizeQR: searchParams.get('sizeQR') || '65',
  };
};
